import React from 'react';
import '../styles/forceModal.css';

function ChartInfoModal({ onClose }) {
  return (
    <div className="force-modal-overlay" onClick={onClose}>
      <div className="force-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="force-modal-close" onClick={onClose}>
          ✕
        </button>

        {/* Header */}
        <div className="force-modal-header" style={{ textAlign: 'center' }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Two Forces of Your Creative Energy Profile</h2>
        </div>

        {/* Content */}
        <div className="force-modal-body">
          <p className="force-modal-description" style={{ marginBottom: '1rem' }}>
            One half of the Wheel of Work is fueled by people who bring <strong>Thinking Forces</strong> (The Spark, The Anchor, The Connector), while the other is powered by people who bring <strong>Doing Forces</strong> (The Decider, The Builder, The Pulse).
          </p>
          <p className="force-modal-description">
            Great creative work happens when both halves stay balanced and in motion.
          </p>
        </div>

        {/* Close Button (Mobile friendly footer) */}
        <div className="force-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChartInfoModal;
